import { render, staticRenderFns } from "./question.vue?vue&type=template&id=6c111a57&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"
import style0 from "./question.vue?vue&type=style&index=0&id=6c111a57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c111a57",
  null
  
)

export default component.exports